document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".projects-sort");
  if (btn)
    btn.addEventListener("change", function () {
      this.form.submit();
    });
});
